import { FilterBoxes } from 'src/models/filter';

import { Callback } from 'src/util/query/models/Callback';

import { DocumentListCallbackStoreContract } from '../interfaces';

export class GetTheDocumentModuleBoxesForTheUserQueryCallBack extends Callback<Array<FilterBoxes>> {
	public constructor(private readonly store: DocumentListCallbackStoreContract) {
		super();
	}

	failureCallbackFunction = (failureResponse: unknown): void => {
		this.logFailureResponse(failureResponse);
	};

	successCallbackFunction = (successResponse: Array<FilterBoxes>): void => {
		this.store.setFilterBoxes(successResponse.filter((filterBox) => filterBox.isVirtual === false));
	};
}
